import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4e837b7e&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=4e837b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e837b7e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/vercel/path0/components/Logo.vue').default,LanguageSwitcher: require('/vercel/path0/components/LanguageSwitcher.vue').default,Header: require('/vercel/path0/components/Header.vue').default})
